/**
 * 파일명 : keypad.js
 * 작성자 : sangmin
 * 작성일 : 2021.03.19
 * 내용   : app에서 사용하는 keypad 함수를 관리한다.
 *
 * 수정이력 :
 */

const KeyPad = {
  inputFocused: null, // 포커스된 요소
  tabIndex: -1, // 자리수가 차면 옮겨다닐 tab 순서
  callback: null, // 결과를 전달받을 콜백함수 키패드 init시 사용한다.

  /**
   * 키패드 초기화
   * @param  {Object} wrap 키패드가 추가될 객체[div]
   * onload 시에 id="wrap"에 keypad를 append 하세요.
   * 호출 예제
   * initKeypad(document.getElementById('wrap'));
   */
  initKeypad: function(wrap) {
    if (!$("#keypad")) return;

    var keypad = `
        <div id="keypad" class="typeB">
          <div class="key-number">
                <button type="" id="num_0" class="btn" value="0">0</button>
                <button type="" id="num_1" class="btn" value="1">1</button>
                <button type="" class="btn is-null" disabled></button>
                <button type="" id="num_2" class="btn" value="2">2</button>
                <button type="" id="num_3" class="btn" value="3">3</button>
                <button type="" id="num_4" class="btn" value="4">4</button>
                <button type="" id="num_5" class="btn" value="5">5</button>
                <button type="" id="num_6" class="btn" value="6">6</button>
                <button type="" id="num_7" class="btn" value="7">7</button>
                <button type="" class="btn is-null" disabled></button>
                <button type="" id="num_8" class="btn" value="8">8</button>
                <button type="" id="num_9" class="btn" value="9">9</button>
          </div>
          <div class="key-action">
                <button type="" class="btn btn-back">backspace</button>
                <button type="" class="btn btn-del">재입력</button>
                <button type="" class="btn btn-ok">확인</button>
        </div>
      `;
    var keyPadObj = this;

    $(wrap).append(keypad);
    // 초기화면에서 키패드 안보이게..
    this.hideKeypad();
    // 초기화면에서 키패드 랜덤으로
    //this.reload();

    //키패드번호 클릭
    $("#keypad .key-number button.btn").unbind("click");
    $("#keypad .key-number button.btn").click(function(e) {
      keyPadObj.clickKey(e.target);
    });

    //키패드번호 클릭
    $("#keypad .key-action button.btn.btn-back").unbind("click");
    $("#keypad .key-action button.btn.btn-back").click(function() {
      keyPadObj.onbtnback();
    });

    $("#keypad .key-action button.btn.btn-del").unbind("click");
    $("#keypad .key-action button.btn.btn-del").click(function() {
      keyPadObj.clearInput();
    });

    $("#keypad .key-action button.btn.btn-ok").unbind("click");
    $("#keypad .key-action button.btn.btn-ok").click(function() {
      if (keyPadObj.callback != null) {
        keyPadObj.callback(keyPadObj.inputFocused.val());
      }
    });

    // 키패드 외부 클릭 시 키패드 숨김처리
    $("html").unbind("click");
    $("html").click(function(e) {
      var isTarget = false;

      $("#keypad, #keypad .btn").each(function(idx, item) {
        if (e.target == item) {
          isTarget = true;
        }
      });

      // 키패드의 버튼이 아니면 객체 이벤트 확인
      if (!isTarget) {
        // 정리 할 필요가 있음...
        var evnetFocus = e.target.onfocus + "";
        var evnetClick = e.target.onclick + "";
        var eventId = e.target.id;
        var eventClsName = e.target.className;
        var eventNodeName = e.target.nodeName;

        // 객체에 키패드 표시 또는 데이터 전송 이벤트가 걸려 있지 않은 경우 키패드 숨김
        if (
          evnetFocus.indexOf("slideKeypad(") === -1 &&
          evnetClick.indexOf("clickSendData(") === -1 &&
          evnetClick.indexOf("clickPossibleCnt(") === -1 &&
          eventId.indexOf("app") === -1 &&
          eventClsName.indexOf("vkeypad") === -1 &&
          eventNodeName.indexOf("TBODY") === -1
        ) {
          keyPadObj.hideKeypad();
        }
      }
    });
  },

  initTabIndex: function() {
    // 배열 초기화
    var keypadObj = this;
    keypadObj.tabIndex = [];
    $(".form-input:visible").each(function(index, item) {
      //[disabled!=disabled]
      keypadObj.tabIndex.push($(item).attr("id"));
    });
  },

  moveKeypad: function() {
    // this.tabIndex가 정의되지 않으면 사용불가
    if (!this.tabIndex) {
      return;
    }

    for (let i = 0; i < this.tabIndex.length; i++) {
      if (this.inputFocused.id === this.tabIndex[i]) {
        // 커서가 배열의 끝이 아니면..
        if (i < this.tabIndex.length - 1) {
          this.inputFocused = document.getElementById(this.tabIndex[i + 1]);
        }
        break;
      }
    }
    this.changeFocus(this.inputFocused);
  },

  clickKey: function(key) {
    // 포커스 된 요소(전역변수)
    var $data = $(this.inputFocused);

    // 콤마가 적용된 Input 은 콤마 처리
    if ($(this.inputFocused).hasClass("js-comma")) {
      let tmp_str = $(this.inputFocused).val() + $(key).val();
      $(this.inputFocused).val(tmp_str);
      //setFormatCurrency(this.inputFocused);
    } else if ($(this.inputFocused).hasClass("js-date")) {
      let tmp_str = $(this.inputFocused).val() + $(key).val();
      $(this.inputFocused).val(tmp_str);
      //setFormatDate(this.inputFocused);
    } else {
      var tmp_str = $(this.inputFocused).val() + $(key).val();
      $(this.inputFocused).val(
        tmp_str.substr(0, $(this.inputFocused).attr("maxlength"))
      );
    }
    $data = $(this.inputFocused);
    let inputVal = $data.val().replace(/[^\d]+/g, ""); //콤마제거.
    // 콤마가 들어간 필드는 maxlength 속성을 쓰면 의도한 자리수 만큼 채워지지 않음.
    let strMaxlength = $data.attr("maxlength") || $data.attr("maxlen");
    let maxlength = null;
    try {
      maxlength = parseInt(strMaxlength);
    } catch (e) {
      //console.log(e);
    }

    // if ($data.attr('maxlength') && $data.val().length >= $data.attr('maxlength') && $data.attr('maxlength') != 'N') {
    if (maxlength && inputVal.length >= maxlength && maxlength != "N") {
      // this.tabIndex 가 마지막 이라면 키패드를 숨긴다.
      if (
        this.inputFocused[0] ===
        $("#" + this.tabIndex[this.tabIndex.length - 1])[0]
      ) {
        //this.hideKeypad();
        if (this.callback != null) {
          this.callback(this.inputFocused.val());
        }
        return false;
      }
      this.moveKeypad();
    }
  },

  shuffle: function(arr_num) {
    for (var i = arr_num.length - 1; i >= 0; i--) {
      var temp = arr_num[i];
      var random_j = Math.floor(Math.random() * i + 1);

      arr_num[i] = arr_num[random_j];
      arr_num[random_j] = temp;
    }

    return arr_num;
  },

  reload: function() {
    var arr_num = new Array(10);
    for (var j = 0; j < 10; j++) {
      arr_num[j] = document.getElementById("num_" + j).value;
    }

    var arr_shuffle = this.shuffle(arr_num);
    for (var i = 0; i < arr_shuffle.length; i++) {
      document.getElementById("num_" + i).value = arr_shuffle[i];
      document.getElementById("num_" + i).innerText = arr_shuffle[i];
    }
  },

  onbtnback: function() {
    // this.tabIndex가 정의되지 않으면 사용불가
    if (!this.tabIndex) {
      return;
    }

    // 포커스 이동 후 값을 다시 받아온다.
    var strMoveFocus = $(this.inputFocused).val();
    $(this.inputFocused).val(
      strMoveFocus.substring(0, strMoveFocus.length - 1)
    );
    // 콤마가 적용된 Input 은 콤마 처리
    //    if ($(this.inputFocused).hasClass('js-comma'))
    //      setFormatCurrency(this.inputFocused);
  },

  changeFocus: function(inputObj) {
    // $(inputObj).val('');
    // 보안키패드 영역이면 리턴
    if ($(inputObj).hasClass("js-seckeypad")) {
      this.hideKeypad();
      $("input").removeClass("input-focus");
      $("input[type=number], input[type=text]").css("background", "");
      $(this.inputFocused).trigger("click");
    } else {
      $("input").removeClass("input-focus");
      $("input[type=number], input[type=text]").css("background", "");
      $(inputObj).addClass("input-focus");
      // $(inputObj).css('background', '#f5f5f5');
      $(inputObj).css("background", "#E6F0FA");
    }
  },
  slideKeypad: function(key, cbComplete) {
    //debugger;
    // 모바일 웹키보드 숨기기
    key.blur();

    // 포커스된 요소
    this.inputFocused = key;
    this.callback = cbComplete;
    this.reload();
    $("#keypad").show();
    this.changeFocus(this.inputFocused);
  },

  hideKeypad: function() {
    $("input").removeClass("input-focus");
    $("input[type=number], input[type=text]").css("background", "");
    $(this.inputFocused).css("background-color", "#FFF");
    $("#keypad").hide();
    $(".brGroup").remove();
    this.callback = null;
  },
  initInputValue: function() {
    $(this.inputFocused).val("");
  },

  clearInput: function() {
    var $data = $(this.inputFocused);
    $($data).val("");
  },
  removeKeypad: function() {
    $("#keypad").remove();
  }
};

KeyPad.install = function(Vue) {
  Vue.prototype.$KeyPad = KeyPad;
};

export default KeyPad;
